const angular = require('angular');
const app = angular.module('learn-directives');

app.directive('surveyViewer', [
  'Application', 'Authorization',
  'SurveyHelper',
  function(
    Application, Authorization,
    SurveyHelper,
  ) {
    return {
      restrict: 'E',
      replace: false,
      scope: {},
      template: require('../../templates/directives/survey-viewer.html'),
      controllerAs: 'surveyViewer',
      controller: [
        '$scope',
        function ($scope) {
          var self = this;
          self.user = Authorization.getAuthToken().user;
          self.features = Application.features.flags();
          self.surveyCompleted = false;
        
          if (!self.features.surveys) {
            Application.navigation.goTo('/explore');
            return;
          }
          self.params = Application.navigation.getUrlParameters();
        
          self.info = {
            surveyId: Application.navigation.getRouteParameters().id || null,
            contentId: self.params.contentId,
            contentType: self.params.contentType,
            loading: true
          }
          
          self.getOne = async () => {
            try {
              self.survey = await SurveyHelper.getOneSurvey(self.info.surveyId);
              $scope.$apply();
            } catch (e) {
              Application.messaging.addMessage({type: 'error', duration: 5, text: `There was an issue retrieving this survey`});
              Application.navigation.goTo('/overview/surveys');
            }
          };


          self.complete = async (responses) => {
            // responses format:
            // {
            //   question1: 'answer',
            //   question2: 'answer'
            // }
            const body = SurveyHelper.constructSubmissionBody(
              responses,
              self.questionsByName,
              self.info.surveyId,
              self.info.contentId,
              self.info.contentType
            );
            body.date_completed = new Date();
            await SurveyHelper.submitSurveyResults(body);
          };

          self.partialComplete = async (responses) => {
            // responses format:
            // {
            //   question1: 'answer',
            //   question2: 'answer'
            // }
            const body = SurveyHelper.constructSubmissionBody(
              responses,
              self.questionsByName,
              self.info.surveyId,
              self.info.contentId,
              self.info.contentType
            );
            await SurveyHelper.submitSurveyResults(body);
          };
        
          self.init = async () => {
            if (!self.info.surveyId) {
              return;
            }
            self.surveyCompleted = await SurveyHelper.userCompletedContentSurvey(self.info.surveyId, self.info.contentId);
            $scope.$apply();
            
            self.companyBranding = {
              colors: Application.COLORS,
              font: Application.CUSTOMFONT
            };
            await self.getOne();
            self.questionsByName = SurveyHelper.constructQuestionsByName(self.survey.survey_json.pages, self.survey.questions);
            self.info.loading = false;
          };
        
          self.init();
        }
      ]
    };
  }
]);
